import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Asset } from 'src/app/shared/models/asset.model';
import { AssetService } from 'src/app/shared/services/asset.service';
import { AppService } from 'src/app/shared/services/app.service';
import { RequestService } from 'src/app/shared/services/request.service';
import { Request } from "../../shared/models/request.model";
import { Attachement } from 'src/app/shared/models/attachement.model';
import {Location} from '@angular/common';
import { CustomerInformation } from '../../shared/models/customerInformation.model';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent implements OnInit {
  public request: Request = new Request();
  public countries: string[] = ["Belgium", "Luxembourg"];
  public languages: string[] = ["English","Français", "Nederlands"];
  public selected: string = "Belgium";
  public asset :  Asset = new Asset();
  private querySub: any;
  private sub: any;
  public type: string = "";
  public stolen: boolean = false;
  public inquiry: boolean = false;
  public broken: boolean = false;
  public information : CustomerInformation = new CustomerInformation()
  
  constructor(private activatedRoute: ActivatedRoute,private assetService: AssetService, private router: Router, private appService: AppService, private requestService: RequestService,private _location: Location, private translate: TranslateService) { }


  ngOnInit(): void {
    let informationString = sessionStorage.getItem("customer");
    if(informationString){
      this.information = JSON.parse(informationString) as CustomerInformation;
    } else {
      switch (this.translate.currentLang){
        case "en": {
          this.information.contactLanguage = this.languages[0];
          break;
        }
        case "fr": {
          this.information.contactLanguage = this.languages[1];
          break;
        }          
        case "nl": {
          this.information.contactLanguage = this.languages[2]
        }
      }
    }
    this.appService.setProgress("75");
    this.asset = this.appService.getAsset();
    this.querySub = this.activatedRoute.queryParams.subscribe(queryParams =>{
      this.type = queryParams['type'];
      this.setBooleanType();
      if(this.broken || this.inquiry){
        this.request = this.requestService.getRequest();
        console.log(this.request)
      }
      this.sub = this.activatedRoute.params.subscribe(params =>{
        this.request.assetNumber = params["serialNumber"];
        if((this.asset.serialNumber == "" || this.asset.serialNumber == undefined) && (this.broken || this.stolen) ){
          
          this.assetService.getAssetBySerialNumber(params["serialNumber"])
                           .subscribe(data => {
                             this.asset = data
                           })
         } else {
           
         }
      });
      
    });

    this.information.contactCountry = this.countries[0];
  }

  private setBooleanType() {
    switch(this.type.toLowerCase()){
        case "broken":{
          this.broken = true;
          this.stolen = false;
          this.inquiry = false;
          break;
        }
        case "stolen": {
          this.broken = false;
          this.stolen = true;
          this.inquiry = false;
          break;
          }
        case "inquiry": {
          this.broken = false;
          this.stolen = false;
          this.inquiry = true;
          break;
        }
    }
  }

  public back(){
    this._location.back();
  }

  public onSubmit() {
    this.request.contactFirstName = this.information.contactFirstName;
    this.request.contactLastName = this.information.contactLastName;
    this.request.contactAddress1 = this.information.contactAddress1;
    this.request.contactAddress2 = this.information.contactAddress2;
    this.request.contactZip = this.information.contactZip;
    this.request.contactCity = this.information.contactCity;
    this.request.contactCountry = this.information.contactCountry;
    this.request.contactLanguage = this.information.contactLanguage;
    this.request.contactPhone1 = this.information.contactPhone1;
    this.request.contactEmail = this.information.contactEmail;
    this.request.companyName = this.information.companyName;
    sessionStorage.setItem("customer", JSON.stringify(this.information));
    this.request.assetId = this.asset.id;
    if(this.broken){
      this.request.requestType = "Broken request";
    } else if(this.stolen){
      this.request.requestType = "Stolen request";
    } else if(this.inquiry){
      this.request.requestType = "Inquiry request";
      
    }
    this.sub = this.requestService.postRequest(this.request).subscribe(data => {
      
      this.request = data;
      this.router.navigate(["/confirm/" + this.request.id])
    });
  }

  public fileChange(e?: Event) {
    let newAttachment = new Attachement();
    const target = e?.target as HTMLInputElement;
    const file: File = (target.files as FileList)[0];


  const maxSize = 2 * 1024 * 1024; // 2 MB in bytes
  if (file.size > maxSize) {
    alert('Het bestand is groter dan 2 MB.');
    target.value = ''; // clear the file input so user can reselect
    return;
  }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
        console.log(reader.result);
        if(reader.result){
          newAttachment.file = reader.result.toString();
        }
    }
    
    console.log(file.name);
    
    newAttachment.path = file.name;
    this.request.attachments.push(newAttachment);
  }

  public selectFile() {
    document.getElementById("fileInput")?.click()
  }

  public CheckValidEmail(){
    
  }

  ngOndestroy(){
    this.sub.unSubscribe();
  }
}
